import { useEffect, useRef, useState } from "react";
import { useWorldMap } from "../../../../contexts/WorldMapContext";
import { inside } from "../../../../contexts/WorldMapContext/constants";
import { DiseaseZonePolygon } from "../../../../contexts/WorldMapContext/Polygon";
import { BarentsWatchService } from "../../../../util/barentswatch/api";
import { datetime } from "../../../../util/library/datetime";
import { DISEASED_ZONE } from "../../../../util/varibles/constants";
import { convertDisease } from "../../../../util/varibles/global";


interface IPropsDiseasedZone {
    source: any[],
}

function DiseasedZoneHover({ source }: IPropsDiseasedZone) {
    const [location, setStore] = useWorldMap(state => state.location);
    const infoRef = useRef({ setStore, ids: new Set(source.map(item => item.id)) })
    useEffect(() => {
        const { setStore, ids } = infoRef.current;

        if (location) {
            const list = source.filter(item => inside(location, item.coordinates[0]));
            const result = list.reduce((rs: Record<string, any[]>, item) => {
                if (rs[item.type])
                    rs[item.type].push(item)
                else
                    rs[item.type] = [item]
                return rs;
            }, [])
            setStore(prev => ({
                zones: { ...prev.zones, ...result }
            }))
        }

        return () => {
            setStore(({ zones: prev = {} }) => {
                return {
                    zones: Object.keys(prev).reduce((rs: typeof prev, key) => {
                        rs[key] = prev[key].filter(item => !ids.has(item.id));
                        return rs;
                    }, {})
                }
            })
        }
    }, [location, source]);

    return null
}

interface IProps {
    isShow?: boolean
    diseases?: { type: DISEASED_ZONE, forskNr: string }[]
}

export default function ActualDiseasedZone({ isShow, diseases }: IProps) {
    const [actualDiseases, setActualDiseases] = useState<any[]>([]);

    useEffect(() => {
        setActualDiseases([]);
        if (!diseases?.length) return;

        let cancelled = false;
        Promise.all(diseases.map((item) => {
            const [, year, day, month] = item.forskNr.split("-");
            const week = datetime(`${day}/${month}/${year}`).week;
            return BarentsWatchService.getDiseaseById(item.type, item.forskNr, year, week)
        }))
            .then(rs => {
                if (cancelled) return;
                const zones = rs.map((item: any, i) => ({ ...convertDisease(item), type: diseases[i].type }));
                setActualDiseases(zones)
            })
            .catch(() => {
                if (!cancelled) setActualDiseases([]);
            });

        return () => { cancelled = true; };
    }, [diseases])

    return <>
        {actualDiseases.map(item => <DiseaseZonePolygon
            key={item.id}
            data={item}
            show={isShow}
            diseaseType={item.type}
        />)}
        {isShow && <DiseasedZoneHover source={actualDiseases} />}
    </>
}
